import { render } from 'preact'
import { SearchBox } from './components/SearchBox/searchBox'
import DataSheetButton from './components/DataSheetButton/dataSheetButton';
import type DrsProps from './types/drsProps';
import type { IL10n } from './types/l10n';

let propsDRS = {} as DrsProps;
try {
    propsDRS = JSON.parse(JSON.stringify(window.__PRELOADED_DRS_PROPS__));
} catch {
    console.warn('Parsing preloaded props failed. Using fallback...');
}

const components: Record<string, any> = {
    'SearchBox': SearchBox,
    'DataSheetButton': DataSheetButton,
}

const localization = propsDRS.localization?.generalL10n || {
    dataSheet: 'datasheet',
    dataSheets: 'datasheets',
    declarationOfComformity: 'declarionofcomformity',
    newSearch: 'newsearch',
    noResultFound: 'noresultfound',
    searchPlaceholder: 'searchplaceholder',
    dataSheetButtonInfo: 'datasheetbuttoninfo',
    dataSheetsButtonInfo: 'datasheetsbuttoninfo',
} as IL10n;

document.querySelectorAll<HTMLElement>('[data-drs-root]').forEach((element) => {
    const name = element.dataset.component;
    const Component = name ? components[name] : null;
    if (!Component) return;
    render(<Component {...propsDRS} l10n={localization} />, element);
});